import React from 'react';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { DataGrid } from '@mui/x-data-grid';
import EditWorkerPopup from './EditWorkerPopup';

const StatusDot = ({ status }) => (
    <span 
      style = {{ 
        display: 'inline-block', 
        width: 10, 
        height: 10, 
        borderRadius: '50%', 
        backgroundColor: status === 'Active' ? 'green' : 'red',
        marginRight: 8 
      }} 
    />
);

function WorkersTable(props) {

    const handleRowClick = (params) => {
        props.setSelectedRow(params.row);  
    };

    const columns = [
        {
            field: 'worker_name',
            headerName: 'Name',
            flex: 1,
            minWidth: 350,
            editable: false,
            renderCell: (params) => (
                <Box display = "flex" alignItems = "center">
                    <StatusDot status = {params.row.status} />
                    {params.value}
                </Box>
            )
        },  
        {
            field: 'warehouse',
            headerName: 'Warehouse',
            flex: 1,
            minwidth: 250,
            editable: false
        }, 
        {
            field: 'timecard_num',
            headerName: 'Timecard #',
            flex: 1,
            minwidth: 250,
            editable: false
        }, 
        {
            field: 'payroll_num',
            headerName: 'Payroll #',
            flex: 1,
            minwidth: 250,
            editable: false
        }, 
        // {
        //     field: 'photo_link',
        //     headerName: 'Photo',
        //     flex: 1,
        //     minWidth: 250,
        //     editable: false
        // },
        {
            field: "edit_button",
            headerName: "Edit",
            align: 'center',
            headerAlign: 'center',
            renderCell: () => {
                return (
                    <IconButton 
                        onClick = {()=> props.setOpenEditWorkerPopup(true) } 
                        variant = "contained" 
                        size = 'medium' 
                        style = {{ backgroundColor: "#666666", color: "#FFFFFF" }}
                    >
                        <EditIcon style = {{ width: '15px', height: '15px' }}/> 
                    </IconButton>
                );
            },
            minWidth: 250,
        }
    ];

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"}>
            <Box className = {props.isMobile ? "mobile-table-box" : "desktop-table-box"}>
                { props.openEditWorkerPopup ? 
                    <EditWorkerPopup
                        open = {props.openEditWorkerPopup} 
                        handleClose = {() => props.setOpenEditWorkerPopup(false)} 
                        setLoading = {props.setLoading}
                        toast = {props.toast}
                        company = {props.company}
                        token = {props.token}
                        workers = {props.workers}
                        setWorkers = {props.setWorkers}
                        selectedRow = {props.selectedRow}
                    /> 
                : null }
                <DataGrid
                    className = {props.isMobile ? "mobile-table" : "desktop-table"}
                    sx = {{ 
                        // width: '95%',
                        width: '70%',
                        height: "1000px",
                        '& .red-row': {
                            backgroundColor: '#FAA0A0', 
                            '&:hover': {
                                backgroundColor: '#cc3333',  
                            },
                        },
                    }}
                    rows = {props.workers}
                    getRowId = {(row) => row.id}
                    columns = {columns}
                    rowsPerPageOptions = {[25, 50, 100]}
                    checkboxSelection = {false}
                    onRowClick = {handleRowClick}
                />
            </Box>
        </Box>
    )

}

export default WorkersTable;